"use client"

import { useState } from "react"
import { DashboardHeader } from "@/components/dashboard-header"
import { DashboardShell } from "@/components/dashboard-shell"
import { PatientSearch } from "@/components/patient-search"
import { PatientHistoryView } from "@/components/patient-history-view"
import { Patient } from "@/types"
import { FileSearch } from "lucide-react"

export default function PatientHistoryPage() {
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null)

  return (
    <div className="md:ml-64">
      <DashboardShell>
        <DashboardHeader
          heading="Patient History"
          text="Search for a patient to view their complete medical and financial history."
        />
        <div className="grid gap-8">
          <PatientSearch onPatientSelect={setSelectedPatient} />
          {selectedPatient ? (
            <PatientHistoryView patientId={selectedPatient.id} />
          ) : (
            <div className="flex flex-col items-center justify-center rounded-lg border border-dashed h-96">
                <FileSearch className="h-16 w-16 text-muted-foreground" />
                <h2 className="mt-6 text-xl font-semibold">Search for a Patient</h2>
                <p className="mt-2 text-sm text-muted-foreground">
                    Use the search bar above to find a patient and view their history.
                </p>
            </div>
          )}
        </div>
      </DashboardShell>
    </div>
  )
} 